import { FC } from 'react';
import { getColorValue } from '@shinetools/sunshine';
import { ComposedChart, Line } from 'recharts';

import { activeDot } from '../../../common';
import CartesianGridNoDashHorizontal from '../CartesianGridNoDashHorizontal';
import Graph from '../Graph';

const placeholderData = [
  {
    date: '2023-10-01',
    newValue: 0,
    oldValue: 0,
  },
  {
    date: '2023-10-30',
    newValue: 0,
    oldValue: 0,
  },
];

export const LoadingGraphSkeletonBody: FC<
  Omit<React.ComponentProps<typeof Graph.Body>, 'children'>
> = (props) => {
  return (
    <Graph.Body {...props}>
      <ComposedChart
        data={placeholderData}
        margin={{ bottom: -10, left: 15, right: 5, top: 0 }}
        syncId="loadingGraph"
      >
        <CartesianGridNoDashHorizontal />

        <Line
          activeDot={activeDot('grey.400')}
          dataKey="oldValue"
          dot={false}
          stroke={getColorValue('grey.400')}
          strokeWidth={2}
          type="monotone"
        />
      </ComposedChart>
    </Graph.Body>
  );
};
